/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JobOrCategorySitemapEntry
 */
export interface JobOrCategorySitemapEntry {
    /**
     * 
     * @type {string}
     * @memberof JobOrCategorySitemapEntry
     */
    jobLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOrCategorySitemapEntry
     */
    jobId?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOrCategorySitemapEntry
     */
    url?: string;
}

/**
 * Check if a given object implements the JobOrCategorySitemapEntry interface.
 */
export function instanceOfJobOrCategorySitemapEntry(value: object): value is JobOrCategorySitemapEntry {
    return true;
}

export function JobOrCategorySitemapEntryFromJSON(json: any): JobOrCategorySitemapEntry {
    return JobOrCategorySitemapEntryFromJSONTyped(json, false);
}

export function JobOrCategorySitemapEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOrCategorySitemapEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'jobLabel': json['jobLabel'] == null ? undefined : json['jobLabel'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function JobOrCategorySitemapEntryToJSON(value?: JobOrCategorySitemapEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jobLabel': value['jobLabel'],
        'jobId': value['jobId'],
        'url': value['url'],
    };
}

